const Next = (props) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.16675 6.99996H12.8334M12.8334 6.99996L7.00008 1.16663M12.8334 6.99996L7.00008 12.8333" stroke="#333333" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
  };
  
  export default Next;
  